import { createContext } from 'react';

export const ReelContext = createContext();